import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { useFinance } from "./FinanceContext";

export function AuditTrailPage() {
  const { audit, snapshots } = useFinance();
  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>
        Audit Trail &amp; Compliance
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        Immutable log · every change captures user, role, version, IP, reason &amp; timestamp. No
        physical deletes (soft delete only).
      </Typography>
      <TableContainer sx={{ maxHeight: "55vh", mb: 2 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Action</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Version</TableCell>
              <TableCell>Timestamp</TableCell>
              <TableCell>Reason</TableCell>
              <TableCell>Detail</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {audit.map((a) => (
              <TableRow key={a.id}>
                <TableCell sx={{ fontWeight: 600 }}>{a.action}</TableCell>
                <TableCell>{a.by}</TableCell>
                <TableCell>{a.role}</TableCell>
                <TableCell>{a.ver}</TableCell>
                <TableCell>{a.date}</TableCell>
                <TableCell>{a.reason || "—"}</TableCell>
                <TableCell>{a.detail}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ p: 2, border: 1, borderColor: "divider", borderRadius: 1 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
          Snapshots ({snapshots.length})
        </Typography>
        <TableContainer sx={{ maxHeight: 300 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Snapshot</TableCell>
                <TableCell>Version</TableCell>
                <TableCell>Captured</TableCell>
                <TableCell>Restorable</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {snapshots.map((s) => (
                <TableRow key={s.id}>
                  <TableCell sx={{ fontWeight: 600 }}>{s.name}</TableCell>
                  <TableCell>{s.ver}</TableCell>
                  <TableCell>{s.date}</TableCell>
                  <TableCell>{s.data ? "Yes" : "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}
